import { CircularProgress, CircularProgressProps } from '@mui/material'
import { FC } from 'react'
import { useIntl } from 'react-intl'

export const C1CircularProgress: FC<CircularProgressProps> = ({ 'aria-label': ariaLabel, ...props }) => {
    const intl = useIntl()
    return <CircularProgress
        aria-label={ariaLabel ?? intl.formatMessage({ id: 'components_circular_progress_aria_label', defaultMessage: 'Loading' })}
        {...props}
    />
}
